/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Resource_Api_TitleInputs */

const en_directory_agents_resource_api_title = /** @type {(inputs: Directory_Agents_Resource_Api_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API reference`)
};

const zh_directory_agents_resource_api_title = /** @type {(inputs: Directory_Agents_Resource_Api_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 参考`)
};

/**
* | output |
* | --- |
* | "API reference" |
*
* @param {Directory_Agents_Resource_Api_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_resource_api_title = /** @type {((inputs?: Directory_Agents_Resource_Api_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Resource_Api_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_resource_api_title(inputs)
	return zh_directory_agents_resource_api_title(inputs)
});
export { directory_agents_resource_api_title as "directory.agents.resource_api_title" }